/* eslint-disable react-hooks/exhaustive-deps */
import { Button, ButtonVariant } from "@blueprintjs/core"
import { HTML, ID } from "src/libs/interfaces/layouts"
import { __ } from "src/libs/utilities"
import { LANDING_TYPE_CONTENT } from "../../data/interfaces"
import CardEditor from "./CardEditor"
import { useEffect } from "react"

/* Protopia Ecosystem component */
export interface ISingleCardScalarProps {
    id: ID
    origin: any
    item: any
    schema: any 
    i: number
    sectionId: ID
    onChange: ( id: ID, value: any ) => void
    onPrev: ( id: ID ) => void
    onNext: ( id: ID ) => void
    onRemove: ( id: ID ) => void
    duplicate: ( id: ID ) => void
}
const SingleCardScalar = (props: ISingleCardScalarProps): JSX.Element => {  
    useEffect(() => {
        
        // console.log(props)
        
    }, [props.item, props.i])
    const getTitle = (): HTML => {
        if(props.item.title) {
            return props.item.title.data
        }
        return __("Card") + " " + props.item.id 
    }
    return <Button className=' btn-stretch p-1 m-1 position-relative' variant={ButtonVariant.OUTLINED}>
            <div className="square2 flex-centered small text-wrap" dangerouslySetInnerHTML={{__html: getTitle()}}>
               
            </div>
            <CardEditor 
                i={props.i} 
                item={props.item} 
                type={LANDING_TYPE_CONTENT.CARDS} 
                cards={props.origin?.cards || []} 
                sectionId={props.sectionId}
                cardsMeatId={props.origin.id}
                duplicate={() => props.duplicate(props.item.id)}
                doDelete={() => props.onRemove(props.item.id)}
                onPrev={() => props.onPrev(props.item.id)}
                onNext={() => props.onNext(props.item.id)}  
            />
        </Button>
}
export default SingleCardScalar